import * as Sentry from "@sentry/react";
import { SENTRY_DSN , SENTRY_ENV} from "../tools/keys/keys";

export function initInstrument() {
    if(!SENTRY_DSN) {return}
    Sentry.init({
        dsn:SENTRY_DSN,
        environment: SENTRY_ENV,
        integrations: [
          // If you're using react router, use the integration for your react router version instead.
          // Learn more at
          // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
          Sentry.browserTracingIntegration(),
        ],
      
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
        tracesSampleRate: 1.0,
      
        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
      });
      
}
initInstrument()